const AllFonts = [
  "roboto",
  "montserrat",
  "orgon-regular",
  "orgon-medium",
  "orgon-bold",
  "poppins-regular",
  "poppins-medium",
  "poppins-semibold",
  "brownstd-light",
  "brownstd-regular",
  "brownstd-bold",
  "futura-medium",
  "futura-bold",
  "clanot-thin",
  "clanot-book",
  "clanot-medium",
  "clanot-bold",
  "smarteyessans-regular",
  "smarteyessans-bold",
  "breda-light",
  "breda-regular",
  "breda-bold",
  "avant-medium",
  "avant-bold"
];
const FontFamilies = {
  // Google fonts
  roboto: {
    fontLinks: {
      google: {
        url: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap",
        format: "google"
      }
    }
  },
  montserrat: {
    fontLinks: {
      google: {
        url: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap",
        format: "google"
      }
    }
  },
  // All self hosted fonts
  "orgon-regular": {
    fontFamily: "Orgon",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/orgon-regular.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/orgon-regular.woff",
        format: "woff"
      }
    }
  },
  "orgon-medium": {
    fontFamily: "Orgon",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/orgon-medium.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/orgon-medium.woff",
        format: "woff"
      }
    }
  },
  "orgon-bold": {
    fontFamily: "Orgon",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/orgon-bold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/orgon-bold.woff",
        format: "woff"
      }
    }
  },
  "poppins-regular": {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/poppins-regular.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/poppins-regular.woff",
        format: "woff"
      }
    }
  },
  "poppins-medium": {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/poppins-medium.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/poppins-medium.woff",
        format: "woff"
      }
    }
  },
  "poppins-semibold": {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/poppins-semibold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/poppins-semibold.woff",
        format: "woff"
      }
    }
  },
  "brownstd-light": {
    fontFamily: "BrownStd",
    fontWeight: 300,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/BrownStd-Light.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/BrownStd-Light.otf",
        format: "otf"
      }
    }
  },
  "brownstd-regular": {
    fontFamily: "BrownStd",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/BrownStd-Regular.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/BrownStd-Regular.otf",
        format: "otf"
      }
    }
  },
  "brownstd-bold": {
    fontFamily: "BrownStd",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/BrownStd-Bold.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/BrownStd-Bold.otf",
        format: "otf"
      }
    }
  },
  "futura-medium": {
    fontFamily: "Futura",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/Futura-Medium.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/Futura-Medium.woff",
        format: "woff"
      }
    }
  },
  "futura-bold": {
    fontFamily: "Futura",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/Futura-Bold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/Futura-Bold.woff",
        format: "woff"
      }
    }
  },
  "clanot-thin": {
    fontFamily: "ClanOT",
    fontWeight: 250,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Thin.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Thin.otf",
        format: "otf"
      }
    }
  },
  "clanot-book": {
    fontFamily: "ClanOT",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Book.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Book.otf",
        format: "otf"
      }
    }
  },
  "clanot-medium": {
    fontFamily: "ClanOT",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Medium.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Medium.otf",
        format: "otf"
      }
    }
  },
  "clanot-bold": {
    fontFamily: "ClanOT",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Bold.woff2",
        format: "woff2"
      },
      otf: {
        url: "https://assets.grandvision.io/global/FF-Clan-OT-Bold.otf",
        format: "otf"
      }
    }
  },
  "smarteyessans-regular": {
    fontFamily: "Smarteyes Sans",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/smarteyessans-regular.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/smarteyessans-regular.woff2",
        format: "woff"
      }
    }
  },
  "smarteyessans-bold": {
    fontFamily: "Smarteyes Sans",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/smarteyessans-bold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/smarteyessans-bold.woff",
        format: "woff"
      }
    }
  },
  "breda-light": {
    fontFamily: "Breda",
    fontWeight: 300,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/breda-light.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/breda-light.woff",
        format: "woff"
      }
    }
  },
  "breda-regular": {
    fontFamily: "Breda",
    fontWeight: 400,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/breda-regular.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/breda-regular.woff",
        format: "woff"
      }
    }
  },
  "breda-bold": {
    fontFamily: "Breda",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/breda-bold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/breda-bold.woff",
        format: "woff"
      }
    }
  },
  "avant-medium": {
    fontFamily: "ITC Avant Garde Gothic Std",
    fontWeight: 500,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/avant-medium.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/avant-medium.woff",
        format: "woff"
      }
    }
  },
  "avant-bold": {
    fontFamily: "ITC Avant Garde Gothic Std",
    fontWeight: 700,
    fontDisplay: "swap",
    fontLinks: {
      woff2: {
        url: "https://assets.grandvision.io/global/avant-bold.woff2",
        format: "woff2"
      },
      woff: {
        url: "https://assets.grandvision.io/global/avant-bold.woff",
        format: "woff"
      }
    }
  }
};
export {
  AllFonts,
  FontFamilies
};
